export default "__VITE_ASSET__86a5f3cd__"